import { initializeApp } from 'firebase/app';
import { connectAuthEmulator, getAuth } from 'firebase/auth';

const app = initializeApp({
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'fake-api-key',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'aspectly-local.firebaseapp.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'aspectly-local',
});

export const auth = getAuth(app);

// Use the page hostname so the emulator matches the opener (e.g. 127.0.0.1 vs localhost).
// A fixed http://localhost:9099 breaks signInWithPopup when the app is opened at http://127.0.0.1:3000.
if (import.meta.env.DEV && typeof window !== 'undefined') {
  connectAuthEmulator(auth, `http://${window.location.hostname}:9099`, {
    disableWarnings: true,
  });
}
